import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { CarCategory } from '@shared/models/car-category.model';
import * as fromGlobalStore from '@shared/store';

@Injectable({
  providedIn: 'root',
})
export class CarTypeMappingService {
  private carTypes: CarCategory[] = [];

  private carTypes$: Observable<CarCategory[]> = this.store.select(fromGlobalStore.getCarCategoriesFeatureState);

  private mappingCache = {};

  constructor(private store: Store<any>) {
    this.carTypes$.subscribe((carTypes) => {
      const carTypesLocalStorage = JSON.parse(localStorage.getItem('car_types'));
      this.carTypes = carTypes.length ? carTypes : carTypesLocalStorage ? carTypesLocalStorage : [];

      if (this.carTypes) {
        localStorage.setItem('car_types', JSON.stringify(this.carTypes));
      }
    });
  }

  public mapIdsToTitles(ids: number[]): string[] {
    if (ids === null) {
      return [];
    }

    const joinedIds = ids.join();

    if (this.mappingCache[joinedIds]) {
      return this.mappingCache[joinedIds];
    } else {
      const result = [];

      ids.forEach((id) => {
        const carType = this.carTypes.find((type) => type.id === id);

        if (carType) {
          result.push(carType);
        }
        result.sort((a, b) => (a.order || Number.MIN_VALUE) - (b.order || Number.MIN_VALUE));
      });

      this.mappingCache[joinedIds] = result.map((type) => type.title);
      return this.mappingCache[joinedIds];
    }
  }
}
